import React from 'react'
import styled from 'styled-components'

const StyledPaginationFooter = styled.div`
	font-size: 16px;
	padding: 15px 0;
	text-align: right;
`

export const PaginationFooter = ({ totalPoints }) => (
	<StyledPaginationFooter className="bold">
		TOTAL: {totalPoints} (Pontos)
	</StyledPaginationFooter>
)
